// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3EhB3","sendOtp":"AuthorizeToLogin_sendOtp__3J7em"};